define('infoArchitecture/composerRoutes',[
    'lib/knockout',
    'viewModels/appView',
    'models/composer/forms/FormType',
    'services/navHelper',
    'services/featureToggleService',
    'services/qm/qualityAuth',
    'services/toastService',
    'infoArchitecture/siteMap'
], function (
    ko,
    appView,
    FormType,
    navHelper,
    featureToggleService,
    qualityAuthService,
    toastService,
    siteMap
) {
    'use strict';

    //===================================================================
    // Routes
    //===================================================================
    var composerRoutes = {
        //==================
        // Evaluation Forms
        //==================
        '#admin/evaluationForms': {
            pageInfo: siteMap.quality.evaluationForms,
            handler: function () {
                appView
                   .subViews.setActiveView('appMain')
                   .subViews.setActiveView('privilegedView')
                   .subViews.setActiveView('qualityFormsMain')
                   .subViews.setActiveView('qualityFormsList')
                   .setFormType(FormType.evaluation);
            },
            fixedHeight: true
        },

        '#admin/evaluationForms/:evalId': {
            pageInfo: siteMap.quality.evaluationForms.evaluationFormEditor,
            handler: function (ctx) {
                appView.subViews.setActiveView('appMain')
                  .subViews.setActiveView('privilegedView')
                  .subViews.setActiveView('qualityFormsMain')
                  .subViews.setActiveView('embeddedQualityFormEditor', FormType.evaluation, ctx.params.evalId);
            },
            onLeave: function () {
                appView.subViews.setActiveView('appMain')
                    .subViews.setActiveView('privilegedView')
                    .subViews.setActiveView('qualityFormsMain')
                    .subViews.setActiveView('evaluationFormEditor')
                    .promptToSaveUnsavedChanges();
            },
            fixedHeight: true, // for embedded evaluation form editor
            regexp: /#admin\/evaluationForms\/([^/]+)$/
        },

        //==================
        // Survey Forms
        //==================
        '#admin/surveyForms': {
            pageInfo: siteMap.quality.surveyForms,
            handler: function () {
                appView
                .subViews.setActiveView('appMain')
                .subViews.setActiveView('privilegedView')
                .subViews.setActiveView('qualityFormsMain')
                .subViews.setActiveView('qualityFormsList')
                .setFormType(FormType.survey);
            },
            fixedHeight: true
        },

        '#admin/surveyForms/:surveyFormId': {
            pageInfo: siteMap.quality.surveyForms.surveyFormEditor,
            handler: function (ctx) {
                appView.subViews.setActiveView('appMain')
                    .subViews.setActiveView('privilegedView')
                    .subViews.setActiveView('qualityFormsMain')
                    .subViews.setActiveView('embeddedQualityFormEditor', FormType.survey, ctx.params.surveyFormId);
            },
            fixedHeight: true,
            regexp: /#admin\/surveyForms\/([^/]+)$/
        },

    };

    return composerRoutes;
});

